// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, string } from 'prop-types'

import {
  Input,
  Label,
} from './styles'

const Checkbox = ({ checked, label, ...props }) => (
  <>
    <Input
      {...props}
      checked={checked}
      data-label={label}
      type={'checkbox'} />
    <Label htmlFor={props.id}>
      <span
        className={'label-icon fa-stack'}
        id={`${props.id}-icon`}>
        <i className={'fa fa-square-o fa-stack-2x'} />
        <i className={`text-green fa fa-stack-1x ${checked ? 'fa-check' : ''}`} />
      </span>
      <span className={'label-text'}>
        {label}
      </span>
    </Label>
  </>
)

Checkbox.propTypes = {
  checked: bool.isRequired,
  id: string.isRequired,
  label: string.isRequired,
}

export default Checkbox
